import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { saveWorkoutDays } from '../../../store/ducks/user';
import SettingsContainer from '../../../components/settings-container';
import MultiSelect from '../../../components/multi-select';

const selectOptions = [
  {
    optionText: 'Sunday',
    iconText: 'su'
  },
  {
    optionText: 'Monday',
    iconText: 'm'
  },
  {
    optionText: 'Tuesday',
    iconText: 'tu'
  },
  {
    optionText: 'Wednesday',
    iconText: 'w'
  },
  {
    optionText: 'Thursday',
    iconText: 'th'
  },
  {
    optionText: 'Friday',
    iconText: 'f'
  },
  {
    optionText: 'Saturday',
    iconText: 'sa'
  }
];

export class PurePreferredWorkoutDays extends Component {
  constructor(props) {
    super(props);

    this.state = {
      preferredWorkoutDays: props.initialValue
    };
  }

  save = async () => {
    try {
      await this.props.saveWorkoutDays(this.state.preferredWorkoutDays);
    } catch (e) {
      /* do nothing */
    }
  }

  getActiveOptions = () => {
    const findIndex = (day) => {
      return selectOptions.findIndex(({ optionText }) => optionText.toLowerCase() === day.toLowerCase());
    };
    return this.state.preferredWorkoutDays.map(findIndex);
  }

  setWorkoutDays = (activeOptions) => {
    const workoutDays = [];
    activeOptions.forEach((idx) => {
      workoutDays.push(selectOptions[idx].optionText);
    });

    this.setState({
      preferredWorkoutDays: workoutDays
    });
  }

  render() {
    return (
      <SettingsContainer
        save={ this.save }
        className="preferred-workout-days-page"
        pageTitle={ this.props.appName === 'wolf' ? 'What days do you want to workout?' : 'What are your preferred workout days?' }
        subtitle
        isValid={ Boolean(this.state.preferredWorkoutDays.length) }
      >
        <MultiSelect
          selectOptions={ selectOptions }
          initialValue={ this.getActiveOptions() }
          setActiveOptions={ this.setWorkoutDays }
          displayIconVersion={ this.props.mediaType === 'tablet' }
        />
      </SettingsContainer>
    );
  }
}

PurePreferredWorkoutDays.propTypes = {
  initialValue: PropTypes.array.isRequired,
  saveWorkoutDays: PropTypes.func.isRequired,
  appName: PropTypes.string,
  mediaType: PropTypes.string
};

PurePreferredWorkoutDays.defaultProps = {
  initialValue: []
};

export default connect(
  state => ({
    initialValue: state.user.workout_days,
    appName: state.config.appName,
    mediaType: state.config.mediaType
  }),
  dispatch => ({
    saveWorkoutDays: preferredWorkoutDays => dispatch(saveWorkoutDays(preferredWorkoutDays))
  }),
  null,
  { withRef: true }
)(PurePreferredWorkoutDays);
